import { faBolt } from '@fortawesome/pro-regular-svg-icons/faBolt'
import { faMicroscope } from '@fortawesome/pro-regular-svg-icons/faMicroscope'
import { faMoneyBill } from '@fortawesome/pro-regular-svg-icons/faMoneyBill'
import { faPollPeople } from '@fortawesome/pro-regular-svg-icons/faPollPeople'
import { faPrescriptionBottleMedical } from '@fortawesome/pro-regular-svg-icons/faPrescriptionBottleMedical'
import { QuickFilter } from './QuickFilter'

export default function QuickFilters() {
  return (
    <div className='hide-scrollbars mx-4 mt-5 flex gap-2 overflow-x-scroll lg:mx-0 lg:overflow-visible'>
      <QuickFilter
        icon={faPollPeople}
        name='No Placebo'
        searchParam='hasNoPlacebo'
        value='true'
      />
      <QuickFilter
        icon={faMoneyBill}
        name='Highly Paid'
        searchParam='phaseList'
        value='Early Phase 1,Phase 1'
      />
      <QuickFilter
        icon={faPrescriptionBottleMedical}
        name='Stay on Current Meds'
        searchParam='hasBackgroundTherapyAllowed'
        value='true'
      />
      <QuickFilter
        icon={faMicroscope}
        name='Pivotal Trials (Near Approval)'
        searchParam='phaseList'
        value='Phase 3'
      />
      <QuickFilter
        icon={faBolt}
        name='Breakthrough Medication'
        searchParam='isBreakthroughTrial'
        value='true'
      />
    </div>
  )
}
